import { Injectable } from '@angular/core';
import { IXId } from 'libraries/service/resources/booking/interfaces/IGetBookings';

export const TOTAL_KEY: string = "TOTAL";
export const DEFAULT_SECTOR_KEY: string = "NO_SECTOR";

@Injectable()
export class KeysMapperService {
    public getKey(sectorKeys: IXId[], defaultKey: string): string {
        if (!sectorKeys || !sectorKeys.length) {
            return defaultKey;
        }

        return sectorKeys
            .map((element: IXId) => element.xId)
            .sort()
            .join(',');
    }

    public parseKey(key: string): string[] {
        return (key || "").split(",");
    }
}